import React from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import './HomeCardBannerBack.scss';

const HomeCardBannerBack = ({ bannerName, Icon, isWebView }) => {
  const backWrapperCn = `home-card-banner-back__wrapper${
    isWebView ? '' : '--mobile'
  }`;

  return (
    <div className="home-card-banner-back__container">
      <div className={backWrapperCn}>
        <div className="home-card-banner-back__top">
          <span>
            <Icon theme="secondary" />
          </span>
          <div className="home-card-banner-back__tittle">
            {trans(`homecard.banner.${bannerName}.title`)}
          </div>
        </div>
        <div className="home-card-banner-back__message">
          {trans(`homecard.banner.${bannerName}.message`)}
        </div>
      </div>
    </div>
  );
};

HomeCardBannerBack.propTypes = {
  bannerName: PropTypes.string.isRequired,
  Icon: PropTypes.node,
  isWebView: PropTypes.bool
};

HomeCardBannerBack.defaultProps = {
  Icon: null,
  isWebView: true
};

export default HomeCardBannerBack;
